import { css } from "@emotion/react";
import useReviewSitesData from "@/hooks/useReviewSitesData";

import { Heading, H5Css, H6Css, H12, H10Css } from "../Typography";
import BenefitsCard from "./BenefitsCard";
import { mq } from "@/constants/breakpoints";
import Image from "next/image";

const SignupPromoPanel = ({ data: { benefits } }: any) => {
  return (
    <div
      css={css`
        background: url("/images/signup/BG.svg"),
          linear-gradient(112.24deg, #048cdd 4.51%, #32b2ff 100.81%);
        background-size: cover;
        background-repeat: no-repeat;
        padding: 44px 32px;
        padding-bottom: 72px;
        flex: 55;
      `}
    >
      <BenefitsCard benefits={benefits} />

      <Heading
        level={5}
        css={css`
          color: #fff;
          text-align: center;
          max-width: 577px;
          margin: auto;
          ${H6Css}
          ${mq["lg"]} {
            ${H5Css}
          }
          ${mq["xs"]} {
          }
        `}
      >
        Trusted by over {process.env.organizationCount} sports organizations.
      </Heading>
      <div
        css={css`
          display: flex;
          justify-content: space-around;
          margin: 60px auto;
          padding: 25px 0;
          background: linear-gradient(
            103.92deg,
            rgba(255, 255, 255, 0.1) -0.74%,
            rgba(190, 220, 255, 0.1) 99.87%
          );
          border: 1px solid rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(40px);
          border-radius: 15px;
          max-width: 577px;
          color: white;
        `}
      >
        <ReviewsRatings type="g2" />
        <ReviewsRatings type="trustpilot" />
        <ReviewsRatings type="capterra" />
      </div>
    </div>
  );
};

export default SignupPromoPanel;

interface ReviewsRatingsProps {
  type: "g2" | "trustpilot" | "capterra";
}

function ReviewsRatings({ type }: ReviewsRatingsProps) {
  const { logo, label, rating } = useReviewSitesData(type);
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      <Image src={logo} alt="logo" height={50} />
      <div css={css({ marginTop: 10, marginBottom: 5 })}>{rating.stars}</div>
      <H12
        css={css`
          margin-top: 1px;
          font-size: 10px;
          font-weight: 350;
          line-height: 12px;
          ${mq["xs"]} {
            ${H10Css};
          }
        `}
      >
        {label}
      </H12>
    </div>
  );
}
